(function () {
    'use strict';

    angular
        .module('app.floorPlans')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'floorplans',
                  config: {
                      abstract: true,
                      url: '/floorplans',
                      template: '<ui-view/>',
                      settings: {
                              authMode: 1
                      },
                      resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                     }
                  },
              },
            {
                state: 'floorplans.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/floorPlans/list.html?v=' + opsIncludeVersion,
                    controller: 'FloorPlansListController',
                    controllerAs: 'vm',
                    title: 'Floor Plans',
                 
                }
            },
            {
                state: 'floorplans.details',
                config: {
                     url: '/detail/:id',
                     templateUrl: 'app/floorPlans/details.html?v=' + opsIncludeVersion,
                     controller: 'FloorPlanDetailsController',
                     controllerAs: 'vm',
                     title: 'Floor Plan',
                 }
            }
          
        ];
    }
})();
